import type { QueryClient } from '@tanstack/react-query';
import type { RouteObject } from 'react-router';

import { Layout } from '../components';
import { authenticateLoader } from '../data-access';

export const authenticateRoute = (queryClient: QueryClient): RouteObject => ({
  element: <Layout isFullScreen passwordProtected={false} />,
  loader: authenticateLoader(queryClient),
  path: 'authenticate',
});
